import { useEffect, useMemo, useRef } from 'react';

const useIntersectionObserver = cb => {
  const containerRef = useRef(null);

  const options = useMemo(
    () => ({
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }),
    [],
  );

  useEffect(() => {
    const observer = new IntersectionObserver(cb, options);
    const node = containerRef.current;
    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
    };
  }, [containerRef, options, cb]);

  return containerRef;
};

export default useIntersectionObserver;
